export enum RuntimeType {
  itp = 'itp',
  onlineWord = 'onlineWord',
  localWord = 'localWord'
}